export const fundItem = {
	fundItemWrap: {
		background: 'var(--default-white)',
		borderRadius: '8px',
		padding: '24px',
		display: 'flex',
		flexDirection: 'column',
		boxShadow: 'var(--box-shadow--1)',
		width: 'calc((100% - 40px)/3)',

		'@media (max-width: 639.98px)': {
			width: 'calc((100% - 12px)/2)',
			padding: '12px',
		},

		'@media (min-width: 1200px)': {
			boxShadow: 'var(--box-shadow--2)',
		},
	},

	fundItemLabel: {
		textAlign: 'center',
		marginBottom: '5px',

		'@media (max-width: 639.98px)': {
			fontSize: '14px',
			lineHeight: '14px',
			marginBottom: '0px',
		},
	},

	fundItemValue: {
		textAlign: 'center',

		'@media (max-width: 639.98px)': {
			fontSize: '16px',
		},
	},
};
